import { restClient } from '@/Core'

import type { IActivityDashboard } from '@/Ship/Contracts/IActivityDashboard'

/** Ендпойнт віджетів справ (`SPEC-015` §3.3). Власник — `ActivityContainer` бека. */
export const ACTIVITY_DASHBOARD_URL = '/services/activities/dashboard'

const toCount = (value: unknown): number => (typeof value === 'number' && Number.isFinite(value) ? Math.max(0, Math.trunc(value)) : 0)

/**
 * Три плитки справ одним запитом: свої (`userUuid = null`) або обраного
 * співробітника — за правом `dashboard_others`.
 *
 * `forceRefresh` — бо 30-секундний GET-кеш ядрового клієнта віддав би старі
 * числа і після події `counters`, і після повернення на сторінку.
 *
 * Помилку не ковтає: стан «—» і повідомлення показує сторінка (Н-3).
 */
export const LoadActivityDashboardTask = async (userUuid: string | null): Promise<IActivityDashboard> => {
    const response = (await restClient.get(
        ACTIVITY_DASHBOARD_URL,
        userUuid ? { searchParams: { user: userUuid } } : {},
        { forceRefresh: true }
    )) as unknown as Partial<IActivityDashboard> | null

    return {
        user: {
            uuid: String(response?.user?.uuid ?? ''),
            fullName: typeof response?.user?.fullName === 'string' ? response.user.fullName : null,
        },
        today: toCount(response?.today),
        week: toCount(response?.week),
        overdue: toCount(response?.overdue),
    }
}
